import React, { ReactElement } from 'react';

import LabelsToolContent from '../LabelsToolContent';
import { Label, LabelMap } from '../../../../../../../common/labels/labelTypes';

type LabelsSheetContentProps = {
    labelMap: LabelMap | undefined;
    currentUserId: string;
    handleClickEdit: (label: Label) => void;
};

const LabelsSheetContent = (props: LabelsSheetContentProps): ReactElement => {
    const { labelMap, ...labelProps } = props;
    const allLabels = Object.values(labelMap || {});

    return (
        <div className="p-4">
            <LabelsToolContent {...labelProps} allLabels={allLabels} />
        </div>
    );
};

export default LabelsSheetContent;
